import React, { FC } from 'react';
import { Row } from 'react-bootstrap';
import { SectionModel } from '../../../../../models/form/section';
import FormField from './field/FormField';

interface Props {
  section: SectionModel;
  fieldProperties: any;
  readOnlyMode?: boolean;
  showHiddenOptions?: boolean;
}

const FormSection: FC<Props> = ({ section, fieldProperties, readOnlyMode, showHiddenOptions }: Props) => {
  return (
    <React.Fragment>
      <Row>
        {section.fields.map((field) => {
          return (
            <FormField
              readOnlyMode={readOnlyMode}
              showHiddenOptions={showHiddenOptions}
              fieldProperties={fieldProperties}
              size={field.size}
              field={field}
              name={field.id}
              key={field.id}
            />
          );
        })}
      </Row>
    </React.Fragment>
  );
};

export default FormSection;
